import Cookies from 'universal-cookie';
import { CURRENT_IDENTIFIER, CURRENT_COMPANY_ID } from './constants';
import { setCookies } from './cookies';

export const getCurrentIdentifier = () : string => {
  const cookies = new Cookies();
  const identifier = cookies.get(CURRENT_IDENTIFIER);

  if (!identifier)
    throw new Error('Biobar current identifier is missing');

  return identifier;
};

export const updateCurrentIdentifierCookie = (identifier : string) : void => {
  setCookies(CURRENT_IDENTIFIER, identifier);
};

export const getCompanyId = () : string => {
  const cookies = new Cookies();
  return cookies.get(CURRENT_COMPANY_ID);
};

export const updateCurrentCompanyIdCookie = (companyId : string) : void => {
  setCookies(CURRENT_COMPANY_ID, companyId);
};

export const deleteCurrentCompanyIdCookie = () : void => {
  const cookies = new Cookies();
  cookies.remove(CURRENT_COMPANY_ID);
};